import type { CuratedDealBuyerDiscountsFormData } from './types';

export const curatedDealBuyerDiscountsFormDefaultValues: CuratedDealBuyerDiscountsFormData = {
  apply_to: null,
  banner_and_video_discount: '',
  ctv_discount: '',
  demand_partner: null,
  min_one_discount_error: '',
  name: '',
  seat_ids: {},
};

export const curatedDealBuyerDiscountSeatTransferListLocalStorageKey = 'TransferList:CuratedDealBuyerDiscounts-seats';
